/**
 * The built-in steps. A runner registers these and may add its own: a step
 * whose code lives in one app only is registered by that app rather than
 * moved here. See `../README.md`.
 */

import type { Step } from '../types.js';
import { companyStep } from './company.js';
import { datesStep } from './dates.js';
import { groundItemsStep } from './ground-items.js';
import { industryCategoryStep } from './industry-category.js';
import { linesStep } from './lines.js';
import { modelCategorizeStep } from './model-categorize.js';
import { modelCorrectStep } from './model-correct.js';
import { modelReadStep } from './model-read.js';
import { orgNumberStep } from './org-number.js';
import { resolveStep } from './resolve.js';
import { storeNameStep } from './store-name.js';
import { totalVoteStep } from './total-vote.js';
import { vatStep } from './vat.js';

export * from './company.js';
export * from './dates.js';
export * from './ground-items.js';
export * from './industry-category.js';
export * from './lines.js';
export * from './model-categorize.js';
export * from './model-correct.js';
export * from './model-read.js';
export * from './org-number.js';
export * from './resolve.js';
export * from './store-name.js';
export * from './support.js';
export * from './total-vote.js';
export * from './vat.js';

export const BUILTIN_STEPS: Step<never>[] = [
  linesStep,
  orgNumberStep,
  datesStep,
  totalVoteStep,
  vatStep,
  storeNameStep,
  companyStep,
  modelReadStep,
  modelCorrectStep,
  groundItemsStep,
  modelCategorizeStep,
  industryCategoryStep,
  resolveStep,
] as unknown as Step<never>[];
